import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import React from 'react';
import Building341 from '../../upload/building@341.jpg';
import Buildings372 from '../../upload/buildings@372.jpg';
import Jungle304 from '../../upload/jungle@304.jpg';
import classes from './Zoom.module.scss';

class Zoom3 extends React.Component {
	render() {
		return (
			<>
				<div className={classes.Gradient}>
					<div className={classes.Title}>engagement</div>
					<div className={classes.SecondaryTitle}>
						Nous soutenons
						<br /> des initiatives humaines,
						<br /> sociales, environnementales
						<br /> et entrepreneuriales.
					</div>
				</div>
				<div className={classes.Content}>
					<div className={classes.TimelineContainer}>
						<div className={classes.TimelineStep}>
							<div className={classes.TimelineSide}>
								<img
									className={[classes.FloatRight].join(' ')}
									src={Jungle304}
									alt="jungle"
								/>
							</div>
							<ArrowRightIcon className={classes.RightArrow} />
							<div className={classes.TimelineSide}>
								<div className={classes.TimelineTitle}>
									Construire une société
									<br /> durable
								</div>
								<div className={classes.TimelineText}>
									<b>Nous sommes acteurs de la société de demain, ensemble.</b>
									<br />
									Notre Groupe soutient des causes pour lesquelles nous prenons
									des engagements sociétaux et environnementaux dans le
									déploiement de l'ensemble de nos activités.
								</div>
							</div>
						</div>
						<div
							className={[classes.TimelineStep, classes.SpecialSide].join(' ')}
						>
							<div className={classes.TimelineSide}>
								<div
									className={[classes.FloatRight, classes.TimelineTitle].join(
										' ',
									)}
								>
									Construire Offrir
									<br /> des services de qualité
								</div>

								<div
									className={[
										classes.TimelineText,
										classes.FloatRight,
										classes.PaddingRight,
									].join(' ')}
								>
									<b>
										Nous mettons tout en œuvre pour vous accompagner dans les
										meilleures conditions.
									</b>
									<br />
									Notre Groupe aide ses clients à gérer le management et la
									valorisation de leurs projets de construction et de
									rénovation.
								</div>
							</div>
							<ArrowLeftIcon className={classes.LeftArrow} />
							<div className={[classes.TimelineSide].join(' ')}>
								<img src={Building341} alt="" />
							</div>
						</div>
						<div className={classes.TimelineStep}>
							<div className={classes.TimelineSide}>
								<img
									className={[classes.ExigenceImg, classes.FloatRight].join(
										' ',
									)}
									src={Buildings372}
									alt=""
								/>
							</div>
							<ArrowRightIcon className={classes.RightArrow} />
							<div className={classes.TimelineSide}>
								<div className={classes.TimelineTitle}>
									Soutenir l’innovation
								</div>
								<div className={classes.TimelineText}>
									<b>
										Nous nous efforçons d'être en recherche constante
										d'améliorations de l'existant.
									</b>
									<br />
									Notre Groupe concentre une partie de son investissement dans
									l’innovation pour atteindre ses objectifs et proposer une
									offre toujours plus innovante à ses clients. Le groupe
									s'entoure de nouvelles entreprises qui apportent, par
									synergie, une croissance positive et de la diversité
									culturelle.
								</div>
							</div>
						</div>
					</div>
					<div className={classes.CenterHolder}>
						<div className={classes.LinkHolder}>
							<div className={classes.Weblink}>groupeduval.com</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}

export default Zoom3;
